import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FilterLabel } from '@lt/components';
import Star from '@lt/components/icons-react/rebrand/Star';
import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';
import type { IFilter } from '../types';

const makeItems = (data) =>
  data.map((item) => {
    const { id: stars } = item;
    const name = stars
      ? Array(stars).fill(<StyledStar />)
      : i18n.t('filters.stars.other');

    return { ...item, name };
  });

const FilterStars = ({
  data,
  className = '',
  isMobile = false,
  onChange,
  onClear,
  currencyCode,
}: IFilter): JSX.Element => {
  const items = useMemo(() => makeItems(data), [data]);
  return (
    <MultichoiceFilterGroup
      data={items}
      className={className}
      isMobile={isMobile}
      onChange={onChange}
      onClear={onClear}
      Filter={FilterStars}
      LabelComponent={StyledFilterLabel}
      currencyCode={currencyCode}
    />
  );
};

const StyledStar = styled(Star)`
  margin-right: 1px;
  height: 14px;
  path {
    fill: var(--secondary);
  }
`;

// Оставил StyledComponent, чтобы не ругалось на типы LabelComponent
const StyledFilterLabel = styled(FilterLabel)``;

export default Object.assign(FilterStars, {
  filterName: 'stars',
  filterLabel: i18n.t('filters.stars.title'),
  valuesLabel: (data) =>
    data
      .filter((item) => item.selected)
      .map((item) => (item.id ? `${item.id}★` : i18n.t('filters.stars.other')))
      .reduce((prev: string, curr: string) => [prev, ', ', curr]),
});
